import React from 'react';
import { usePrivacyPolicyCheck } from '../../../hooks/usePrivacyPolicyCheck';
import PrivacyPolicyModal from './PrivacyPolicyModal';

const PrivacyPolicyChecker: React.FC = () => {
  const { accepted, isLoading, markAsAccepted } = usePrivacyPolicyCheck();

  // Don't show anything while loading or if already accepted
  if (isLoading || accepted) {
    return null;
  }

  // Show modal if not accepted
  return <PrivacyPolicyModal onAccept={markAsAccepted} />;
};

export default PrivacyPolicyChecker;
